import React from 'react';

import styles from './index.module.scss';
import JoinOurCommunity from '../TippingArticles/JoinOurCommunity';
import AllAboutTipping from '../Home/AllAboutTipping';
import {
  IconComments,
  IconPeopleCommunity,
  IconTransparency,
} from '../../Common/Icon';

const content = [
  {
    key: '1',
    icon: <IconTransparency />,
    title: 'Transparency',
    text: 'Promoting clear, fair, and accessible tipping practices for everyone.',
  },
  {
    key: '2',
    icon: <IconComments />,
    title: 'Empowerment',
    text: 'Giving both workers and tippers a voice to create better experiences.',
  },
  {
    key: '3',
    icon: <IconPeopleCommunity />,
    title: 'Community',
    text: 'Building a trusted space where shared stories and insights drive.',
  },
];

export default function OurMissionContent(): React.ReactElement {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.content}>
            <h2>Our Mission</h2>
            <h4>
              Tipping is subjective. Who decides how much is appropriate to tip?
              Is tipping for service anymore or expected regardless of service
              quality? Here at TippingGuide.com, we want to answer these
              questions. Many people feel that American tipping culture has
              gotten out of control.
            </h4>
            <div className={styles.cards}>
              {content.map((item) => (
                <div key={item.key} className={styles.card}>
                  <div>{item.icon}</div>
                  <h5>{item.title}</h5>
                  <h6>{item.text}</h6>
                </div>
              ))}
            </div>
            <div className={styles.text}>
              <span>
                The increase in mobile payments, iPads at checkout, and
                suggested tip amounts have only increased these expectations,
                often leading to anxiety, uncertainty, or frustration when
                tipping. Our goal at TippingGuide.com is to facilitate the
                conversation about tipping and expectations because ultimately,
                you decide! So, we ask you to share your two cents… how do you
                tip?
                <br />
                <br />
                We believe it is important to discuss both the customer
                experience and service provider (worker) expectations when it
                comes to tipping. Therefore, we ask that you respond either as a
                customer or worker, if you work in a certain industry, and share
                your experiences or expectations of being tipped. Is there
                alignment between the two? If not, what is the disconnect? Can
                we bridge the gap and together decide the appropriate amount to
                tip in various situations.
              </span>
            </div>
            <h3 style={{ marginTop: 30 }}>Tip Smarter</h3>
            <span style={{ fontWeight: 700 }}>
              At TippingGuide.com, our primary goal is to provide a platform for
              consumers and service workers to learn about and help shape
              American tipping culture. With the rise of electronic payments,
              tip screens, and an increasing number of industries that expect
              tips, many Americans feel that tipping culture in the USA is out
              of control. By joining our online community, users can view data
              about tipping expectations and consumer averages, empowering them
              to make well-informed tipping decisions.
            </span>
          </div>
        </div>
      </div>
      <AllAboutTipping />
      <JoinOurCommunity />
    </>
  );
}
